import { render } from "./ClientLoader.vue?vue&type=template&id=f1376040&ts=true"
import script from "./ClientLoader.vue?vue&type=script&lang=ts"
export * from "./ClientLoader.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__